import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-darkGreen text-white pt-12 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Kontakt Informationen */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Kontakt</h3>
            <div className="space-y-2">
              <p>Maya Kälin</p>
              <p>Dipl. Fusspflegerin SFPV</p>
              <p>Dorfplatz 6</p>
              <p>8852 Altendorf</p>
              <a href="tel:+41774049528" className="block hover:text-lightGreen">+41 77 404 95 28</a>
              <a href="mailto:maya.kaelin@bluewin.ch" className="block hover:text-lightGreen">maya.kaelin@bluewin.ch</a>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-lightGreen transition-colors">Startseite</Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="hover:text-lightGreen transition-colors">Über mich</Link>
              </li>
              
              <li>
                <Link to="/preise" className="hover:text-lightGreen transition-colors">Preise</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-lightGreen transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Öffnungszeiten */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Öffnungszeiten</h3>
            <p className="mb-2">Nach Vereinbarung</p>
            <div className="mt-4">
              <img 
                src="/images/sfpv_badge.png" 
                alt="SFPV Badge" 
                className="max-w-[120px] h-auto"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-lightGreen/30 mt-8 pt-8">
          {/* Website Credits */}
          <div className="text-center mb-4">
            <p className="text-sm text-white/70 mb-2">Website erstellt von:</p>
            <a 
              href="https://opti-site.ch" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 hover:opacity-80 transition-opacity"
            >
              <img 
                src="/images/logo_optisite.png" 
                alt="OptiSite Logo" 
                className="h-6 w-auto"
              />
              <span className="text-sm text-white/90 hover:text-white">opti-site.ch</span>
            </a>
          </div>
          
          {/* Copyright */}
          <div className="text-center text-sm">
            <p>&copy; {new Date().getFullYear()} PODO FEET - Maya Kälin. Alle Rechte vorbehalten.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 